export const STRIPE_AUTHORIZATION_BASE_URL = 'https://connect.stripe.com/oauth/authorize'
